import { Button, MagellanPopup } from 'components/atoms';
import YearSelectCard from 'components/molecules/card/year-select-card/YearSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { RELEASE_TYPE } from 'services/music-product-digital/types/enums';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IYearSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectYear?: (year: RELEASE_TYPE | null, actions: PopupActions) => void;
  open?: boolean;
  initialYear?: number | null;
  displayMode?: boolean;
}

const YearSelectPopupForm = ({
  trigger,
  onSelectYear,
  open,
  initialYear = null,
  displayMode,
}: IYearSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [yearSearch, setYearSearch] = useState('');
  const [selectedYear, setSelectedYear] = useState<RELEASE_TYPE | null>(null);

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setSelectedYear(initialYear);
      }}
      onClose={() => {
        setSelectedYear(null);
        setYearSearch('');
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.year')}</MagellanPopup.Header>

        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {new Array(100)
            .fill(' ')
            .map((_, index) => new Date().getFullYear() - index)
            .map((year) => (
              <YearSelectCard
                key={year}
                year={year}
                isSelected={selectedYear === year}
                onClick={(newYear) =>
                  setSelectedYear((prev) => (prev === newYear ? null : newYear))
                }
              />
            ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current && onSelectYear && onSelectYear(selectedYear, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default YearSelectPopupForm;
